require('./ember/compare')
require('./ember/computed-sum')
require('./ember/cp-auto-destroy')
require('./ember/data-attributes')
require('./ember/inject')
require('./ember/merged-array')
require('./ember/o')
